import { h } from "preact"

import iconA from "./assets/A.svg"
import iconB from "./assets/B.svg"
import iconC from "./assets/C.svg"
import iconD from "./assets/D.svg"
import iconE from "./assets/E.svg"
import iconF from "./assets/F.svg"
import iconG from "./assets/G.svg"

const icons = {
  A: iconA,
  B: iconB,
  C: iconC,
  D: iconD,
  E: iconE,
  F: iconF,
  G: iconG
}

export const EnergyLabel = ({ level, height, width, deviceName = "" }) => {
  if (!icons[level]) return null

  return (
    <img
      src={icons[level]}
      {...(height ? { height } : {})}
      {...(width ? { width } : {})}
      alt={`Classe énergétique,${deviceName ? ` ${deviceName},` : ""} classe ${level}, échelle allant de A à G`}
    />
  )
}
